'use strict';
angular.module('schoolLinqApp').factory('purchaseOrderService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/purchaseOrder';

		function getPurchaseOrders() {
			return $http.get(endpoint + '/list');
		}

		function getRequisitions() {
			return $http.get(endpoint + '/requisitions');
		}

		function getPurchaseOrderImagePreview(purchaseOrderId, copyNumber) {
			return $http.get(endpoint + '/getpopreviewimage', {
				params: { purchaseOrderId: purchaseOrderId, copyNumber: copyNumber },
			});
		}

		function getPurchaseOrder(id) {
			return $http.get(endpoint + '/' + id);
		}

		function searchPurchaseOrders(filter) {
			return $http.get(endpoint + '/search', {
				params: {
					PurchasingType: filter.purchasingType,
					Type: filter.type,
					Search: filter.search,
					FromNumber: filter.poFrom,
					ToNumber: filter.poTo,
					FiscalYear: filter.fiscalYear,
					StatusId: filter.statusId,
					FromDate: filter.fromDT,
					ToDate: filter.toDT,
					VendorId: filter.vendorId,
					OnlyIncludeDelivered: filter.onlyIncludeDelivered,
					OrderBy: filter.propertyName,
					OrderByDescending: filter.reverse,
					PageSize: filter.pageSize,
					StartIndex: filter.startIndex,
				},
			});
		}

		function searchPurchaseOrdersByNumber(filter) {
			return $http.get(endpoint + '/searchbynumber', {
				params: {
					PONumber: filter.poNumber,
					StatusId: filter.statusId,
					Limit: filter.limit,
				},
			});
		}

		function addPurchaseOrder(purchaseOrder) {
			return $http.post(endpoint + '/add', purchaseOrder);
		}

		function updatePurchaseOrder(purchaseOrder) {
			return $http.post(endpoint, purchaseOrder);
		}

		function approveRequisitions(reqIds, nextApprover) {
			const approveModel = {
				ReqIds: reqIds,
				NextApprover: nextApprover,
			};
			return $http.post(endpoint + '/approve-requisitions', approveModel);
		}

		function emailPurchaseOrder(purchaseOrderToSend) {
			return $http.post(endpoint + '/emailpos', purchaseOrderToSend);
		}

		function checkPurchaseOrderStatus(purchaseOrderToSend) {
			return $http.post(endpoint + '/checkpostatus', purchaseOrderToSend);
		}

		function getPurchaseOrderFiscalYearsByVendorId(vendorId) {
			return $http.get(endpoint + '/fiscalyearsbyvendorid', {
				params: { vendorId: vendorId },
			});
		}

		function deletePO(id) {
			return $http.delete(endpoint, { params: { id: id } });
		}

		function closePO(id) {
			return $http.post(endpoint + '/close', null, { params: { id: id } });
		}

		function getPOSetupInfo(poId) {
			return $http.get(endpoint + '/getposetupinfo', {
				params: { poId: poId },
			});
		}

		function getApprovalUsers() {
			return $http.get(endpoint + '/approval-users');
		}

		return {
			getPurchaseOrders: getPurchaseOrders,
			getRequisitions: getRequisitions,
			getPurchaseOrderImagePreview: getPurchaseOrderImagePreview,
			getPurchaseOrder: getPurchaseOrder,
			searchPurchaseOrders: searchPurchaseOrders,
			addPurchaseOrder: addPurchaseOrder,
			updatePurchaseOrder: updatePurchaseOrder,
			approveRequisitions: approveRequisitions,
			emailPurchaseOrder: emailPurchaseOrder,
			checkPurchaseOrderStatus: checkPurchaseOrderStatus,
			getPurchaseOrderFiscalYearsByVendorId: getPurchaseOrderFiscalYearsByVendorId,
			searchPurchaseOrdersByNumber: searchPurchaseOrdersByNumber,
			deletePO: deletePO,
			closePO: closePO,
			getPOSetupInfo: getPOSetupInfo,
			getApprovalUsers: getApprovalUsers,
		};
	},
]);
